import { createSyncAction } from '@bimser/core';
import * as ActionTypesMain from './actionTypes';

export default function setActiveFlexPanelAction(data: string) {
	const action = createSyncAction(ActionTypesMain.SET_ACTIVE_FLEX_PANEL, data);

	return action;
}
